import apiClientService from "./ApiClientService";

// „De sunat” (administratori, manageri): GET /call-tasks?status=OPEN|DONE, PATCH /call-tasks/:id { result, note }

async function readOrThrow(res, fallback) {
   if (res.ok) return res.json();
   let msg = fallback;
   try {
      const err = await res.json();
      if (err?.message) msg = Array.isArray(err.message) ? err.message.join(" ") : err.message;
   } catch {}
   const error = new Error(msg);
   error.status = res.status;
   throw error;
}

export async function fetchCallTasks(status = "OPEN") {
   return readOrThrow(await apiClientService.get(`/call-tasks?status=${status === "DONE" ? "DONE" : "OPEN"}`), "Nu am putut încărca lista.");
}

export async function markCallDone(id, result, note) {
   return readOrThrow(
      await apiClientService.patch(`/call-tasks/${Number(id)}`, JSON.stringify({ result, note: note || undefined })),
      "Nu am putut salva apelul.",
   );
}
